/*
=====================================================
🔧 build_purchase_receipt_view.js

Purpose:
- Converts LGV order documents into browser receipt format
- Keeps success page presentation consistent with email receipt
- Handles Power Up display and configuration links

Features:
- Formats package information
- Formats purchased Power Ups
- Creates configuration links
- Formats totals
=====================================================
*/


const ADDON_CONFIG = {

  passport: {
    name: "Engagement Passport",
    amountCents: 4900,
    path: "engagement",
  },

  auction: {
    name: "Silent Auction",
    amountCents: 4900,
    path: "auctions",
  },

  tickets: {
    name: "Ticket Sales",
    amountCents: 4900,
    path: "tickets",
  },

  vendorPayments: {
    name: "Vendor Payments",
    amountCents: 2900,
    path: "vendors_list",
  },

  sponsorPayments: {
    name: "Sponsor Payments",
    amountCents: 2900,
    path: "sponsors_list",
  },

  store: {
    name: "Event Merch Store",
    amountCents: 2900,
    path: "store_products",
  },

  social: {
    name: "Social Engine",
    amountCents: 4900,
    path: "promotion_dashboard",
  },

};


function formatMoney(amountCents = 0) {

  return `$${(
    Number(amountCents || 0) / 100
  ).toFixed(2)}`;

}



export function buildPurchaseReceiptView(order = {}) {


  const eventSlug =
    order.activatedEventSlug ||
    "";



  const selectedAddOns =
    Array.isArray(order.selectedAddOns)
      ? order.selectedAddOns
      : [];



  const addons =
    selectedAddOns
      .filter(
        (key) =>
          ADDON_CONFIG[key]
      )
      .map(
        (key) => {

          const addon =
            ADDON_CONFIG[key];


          return {

            key,

            name:
              addon.name,

            amountCents:
              addon.amountCents,

            amountDisplay:
              formatMoney(
                addon.amountCents
              ),

            configUrl:
              eventSlug
                ? `/${eventSlug}/${addon.path}`
                : "",

          };

        }
      );



  return {


    orderId:
      order.id || "",

    event: {

      name:
        order.eventName ||
        order.eventName ||
        order.activatedEventSlug ||
        order.requestId ||
        "Let's Go Vote Event",

      slug:
        eventSlug,

    },

    package: {

      name:
        order.packageName ||
        "LGV Event Package",

      amountCents:
        9900,

      amountDisplay:
        formatMoney(9900),

    },



    addons,



    total: {

      amountCents:
        order.amountCents || 0,

    },

    help: {

      title:
        "Need Help?",

      steps: [
        "Complete your event details",
        "Configure your purchased Power Ups",
        "Add categories and entries",
        "Customize your event page",
        "Share your QR voting link",
      ],

      email:
        "hello@letsgovote.app",

    }

  };

}

